







































import { Vue, Component, Watch } from 'vue-property-decorator'
import messenger from 'src/assets/messenger'
import ChatLayout from 'src/components/chat/Layout.vue'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'

@Component({
  components: {
    ChatLayout,
    PersonAvatar
  }
})
export default class Messenger extends Vue {
  messenger = messenger
  chat = {
    history: messenger.chat.history,
    load (done: (stop?: boolean) => void) {
      messenger.activityLoadHistory(done)
    },
    async send (message: string) {
      await messenger.send(message)
    }
  }

  @Watch('$q.appVisible')
  async read (visible: boolean) {
    if (visible && this.messenger.chat.activity && this.messenger.chat.activity.unreadMessages) {
      await this.messenger.activityRead(this.messenger.chat.activity)
    }
  }

  openStudentView () {
    // @ts-ignore
    const url = `/presenter/${this.messenger.chat.activity.courseId}/student/${this.messenger.chat.activity.student.id}/`
    if (url !== this.$route.path) {
      this.$router.replace(url)
    }
    this.$emit('close')
  }
}
